module.exports = __webpack_public_path__ + "img/nserc.2e5bb4a7.png";